import { render, staticRenderFns } from "./WorldLinks.vue?vue&type=template&id=17653c71&scoped=true&"
import script from "./WorldLinks.vue?vue&type=script&lang=js&"
export * from "./WorldLinks.vue?vue&type=script&lang=js&"
import style0 from "./WorldLinks.vue?vue&type=style&index=0&id=17653c71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../contacts/spa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17653c71",
  null
  
)

export default component.exports